import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';
import {autorun, runInAction} from 'mobx';
import {addLocaleData, IntlProvider} from 'react-intl';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import he from 'react-intl/locale-data/he';
import it from 'react-intl/locale-data/it';
import de from 'react-intl/locale-data/de';

import {getLocaleMessages, setIntlProvider} from '../../utils/localizationUtility';

addLocaleData([...en, ...es, ...he, ...it, ...de]);

@inject('appStore', 'userStore')
@observer
class HotSwappingIntlProvider extends Component {
    componentDidMount() {
        autorun(() => {
            setIntlProvider(this.props.userStore.selectedLocale || 'en-US');
            runInAction(() => {
                this.props.userStore.initializedLocale = this.props.userStore.selectedLocale;
            });
        });
    }

    render() {
        return (
            <IntlProvider
                locale={this.props.userStore.selectedLocale}
                messages={getLocaleMessages(this.props.userStore.selectedLocale)}
                textComponent={Fragment}>
                {this.props.children}
            </IntlProvider>
        );
    }
}

export default HotSwappingIntlProvider;
